var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDuplicateToolbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2 2 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 11.667V11.667C16.3334 11.0457 16.3334 10.7351 16.2319 10.4901C16.0966 10.1634 15.837 9.90381 15.5103 9.76849C15.2653 9.66699 14.9547 9.66699 14.3334 9.66699H12.3334C11.0763 9.66699 10.4478 9.66699 10.0573 10.0575C9.66675 10.448 9.66675 11.0766 9.66675 12.3337V14.3337C9.66675 14.9549 9.66675 15.2655 9.76824 15.5106C9.90357 15.8373 10.1631 16.0968 10.4898 16.2322C10.7349 16.3337 11.0455 16.3337 11.6667 16.3337V16.3337",
    stroke: "currentColor",
    strokeWidth: 0.933333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6667,
    y: 13.667,
    width: 6.66667,
    height: 6.66667,
    rx: 1.33333,
    stroke: "currentColor",
    strokeWidth: 0.933333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicateToolbar);
export default __webpack_public_path__ + "static/media/IconDuplicate-toolbar.1ff017199bb3c436da8d3fcf885260ef.svg";
export { ForwardRef as ReactComponent };